module.exports = __webpack_public_path__ + "img/explosion.fde40866.png";